import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GUIDE_INDEX_URL, GUIDE_POSTS } from "./guidePosts";
import "./Guide.css";

const GuidePage = () => {
  return (
    <div className="guide-page guide-select">
      <Helmet>
        <title>마케팅 게시글 | 올려줌</title>
        <meta
          name="description"
          content="네이버 쇼핑 순위 상승처럼, 검색으로 찾는 사람이 올려줌 가이드 글을 바로 볼 수 있도록 주제별 게시글을 모았습니다."
        />
        <meta
          name="keywords"
          content="올려줌 가이드, 네이버 쇼핑 키워드 분석, 네이버 쇼핑 순위 상승, 쇼핑 검색 유입"
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={GUIDE_INDEX_URL} />
        <meta property="og:title" content="마케팅 게시글 | 올려줌" />
        <meta
          property="og:description"
          content="네이버 쇼핑 순위 상승처럼, 검색으로 찾는 사람이 바로 읽을 수 있는 올려줌 가이드입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={GUIDE_INDEX_URL} />
        <meta property="og:site_name" content="올려줌" />
        <meta property="og:locale" content="ko_KR" />
      </Helmet>

      <main className="guide-select-panel">
        <p className="guide-kicker">마케팅 게시글</p>
        <h1>마케팅에 도움이 되는 게시글을 읽어보세요!</h1>
        <ul className="guide-select-list">
          {GUIDE_POSTS.map((post) => (
            <li key={post.slug}>
              <Link to={`/guide/${post.slug}`} className="guide-select-card">
                <time dateTime={post.publishedAt}>{post.publishedAt}</time>
                <strong>{post.title}</strong>
                <span>{post.description}</span>
              </Link>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default GuidePage;
